import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { useAppSelector } from "../../redux/hooks";
import { useDispatch } from "react-redux";
import useButtonStyles from "../../styles/useButtonStyles";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import {
  columnsAdmin,
  columnsMerchant,
} from "../../static-models/ListPhysicalVoucherData";
import theme from "../../theme";

import { financeActions } from "../../redux/slices/financeSlice";
import { formatDateReport, getEncodedValue } from "../forms/utility";
import { constant } from "../../constants";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import formatDate, {
  dateFormat,
  getFormattedDate,
} from "../../util/dateFormat";
import InputProps, {
  DualInputProps,
} from "../../pages/SharedContents/InputProps";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import BasicModal from "../ui/BasicModal";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import {
  SearchToolTip,
  filterConstants,
  hashKey,
  hashValue,
  modelName,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from "../../services/ApiServices/export";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import useDateFilter from "../../Hooks/Filters/useDateFilter";

export const merchantColumns: TableColumn[] = [
  { key: "reportId", header: "Report ID", searchable: true },
  { key: "merchant", header: "Merchant", searchable: true },
  { key: "companyName", header: "Company Name", searchable: true },
  { key: "totalAmount", header: "Total Amount", searchable: true },
  { key: "noOfVouchers", header: "No. of Vouchers" },
  { key: "submissionDate", header: "Submitted Date" },
  { key: "receivedDate", header: "Received Date" },
  { key: "rejectionReason", header: "Rejection Reason" },
  { key: "createdBy", header: "Created By", searchable: true },
  { key: "status", header: "Report Status", filterable: true },
];

export interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
  dropdownOptions?: string[];
  isCheckbox?: boolean;
}
interface PVoucherData {
  id: string;
  reportId: string;
  merchant: number;
  merchantID: string;
  companyName: number;
  voucherType: string;
  totalAmount: string;
  noOfVoucher: string;
  submissionDate: string;
  rejectionReason: string;
  status: string;
}
const ReimbursementPhysicalVoucher = () => {
  const physicalVoucherStateFilter = [
    { id: filterConstants.Pending, label: filterConstants.Pending },
    { id: filterConstants.Accept, label: filterConstants.Accept },
    { id: filterConstants.Reject, label: filterConstants.Reject },
  ];
  const { getUserPermission: getPhysicalPermission } = usePermissionGetter(
    "finance",
    "reimbursment_physical_voucher"
  );
  const dispatch = useDispatch();
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const { merchantId } = selectedMerchatDetails;
  const buttonStyles = useButtonStyles();
  const [currentRoute, setCurrentRoute] = useState<string>(
    window.location.pathname
  );
  const buttonStyle = useButtonStyles();
  const [errorAPI, setErrorAPI] = useState<boolean>(false);
  const [loadingAPI, setLoadingAPI] = useState<boolean>(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const physicalVoucherData = useAppSelector(
    (state: any) => state.persistReducers.financeSlice?.physicalVoucher
  );
  const [open, setOpen] = useState(false);
  const [approval, setApproval] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [apiError, setApiError] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState("Something Went Wrong");
  const [selectedItems, setSelectedItems] = useState<PVoucherData[]>([]);
  const [openExport, setOpenExport] = useState(false);
  const [exportEmail, setExportEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [visited, setVisited] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const currentDate = formatDateReport(new Date().toISOString());
  const [openAddDeduct, setOpenAddDeduct] = useState<boolean>(false);
  const [updatedDateFilter, setupdatedDateFilter] = useState({});
  const [selectedOption, setSelecteOption] = useState("");
  const [isApiCall, setIsApiCall] = useState(true);
  const [lastKey, setLastKey] = useState(null);
  const [pvData, setPVData] = useState([]);
  const [filterActive, setFilterActive] = useState(false);
  const [updatedAmntInput, setUpdatedAmntInput] = useState({});

  const searchInputRef = useRef<HTMLInputElement>();
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();

  const entityConstants = {
    amount: "total_amount",
    submittedDate: "submitted_date",
    receivedDate: "reimbursement_date",
    createdDate: "created_date",
    status: "report_status",
    amount_from: "amount_from",
    amount_to: "amount_to",
  };
  const { selectedDates, onUpdateFiltedDate, valueWithOperator, onResetDate } =
    useDateFilter([
      entityConstants.submittedDate,
      entityConstants.receivedDate,
    ]);
  useEffect(() => {
    if (isApiCall) bindFilter();
  }, [isApiCall]);
  const handleClickOpen = () => {
    setOpen(true);
    setOpenAddDeduct(false);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenAddDeduct(false);
  };

  const handleExport = () => {
    setOpenExport(true);
  };
  const handleExportClose = () => {
    setOpenExport(false);
  };

  const HandleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setExportEmail(e.target.value);
    isValidEmail(e.target.value);
  };

  const headerMapping: Record<string, string> = {
    reportId: "Report ID",
    merchant: "Merchant",
    companyName: "Company Name",
    voucherType: "Voucher Type",
    totalAmount: "Total Amount",
    noOfVouchers: "No. of vouchers",
    submissionDate: "Submission Date",
    receivedDate: "Received Date",
    rejectionReason: "Rejection Reason",
    createdBy: "Created By",
    status: "Report Status",
    merchantID: "Merchant ID",
  };

  const formatCSVData = (data: any[]) => {
    const order = [
      "Report ID",
      "Merchant",
      "Company Name",
      "Total Amount",
      "No. of vouchers",
      "Submission Date",
      "Received Date",
      "Rejection Reason",
      "Created By",
      "Report Status",
    ];
    function sortByOrder(object: any, order: any) {
      const sortedObject: any = {};
      order?.forEach((key: any) => {
        if (object?.hasOwnProperty(key)) {
          sortedObject[key] = object[key];
        }
      });
      return sortedObject;
    }
    return data?.map((csvRow) => {
      const renamedRow = {
        ...csvRow,
      };
      const excludedColumns = [
        "navigateTo",
        "id",
        "reportIdDetail",
        "voucherType",
        "merchantID",
      ];
      for (const key in renamedRow) {
        if (excludedColumns.includes(key)) {
          delete renamedRow[key];
        } else {
          if (headerMapping[key]) {
            renamedRow[headerMapping[key]] = renamedRow[key];
            delete renamedRow[key];
          }
        }
      }
      if (renamedRow.navigateTo) {
        delete renamedRow.id;
      }

      return sortByOrder(renamedRow, order);
    });
  };
  const getNormalFilter = () => {
    let filterItems = [
      {
        fieldValue: "voucher_type",
        operator: operatorConstants.equal,
        value: "physical",
      },
    ];
    if (currentRoute === "/merchant/physicalVoucher") {
      const merchantid = {
        fieldValue: "id",
        operator: operatorConstants.equal,
        value: merchantId,
      };
      filterItems = [...filterItems, merchantid];
    }
    return filterItems;
  };
  const getParam = () => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const filterItems = getNormalFilter();
    const params = {
      hashData: hashValues,
      filterData: filterItems,
    };
    return params;
  };
  const getAPiURL = (queryParam?: any) => {
    let apiURL = `${process.env.REACT_APP_API_URL}`;
    apiURL +=
      currentRoute === "/merchant/physicalVoucher"
        ? `${APIConstants.getMerchantReport}`
        : `${APIConstants.physicalVoucher}`;
    const filterParams = getHashURL(queryParam ? queryParam : getParam());
    const module =
      currentRoute === "/merchant/physicalVoucher"
        ? APIModuleConstants.merchantPvoucher
        : APIModuleConstants.pvoucher;
    if (!pvData.length) getTotalRecordsCount(module, filterParams);
    apiURL += `?${filterParams}`;
    apiURL += `&module=finance&feature=reimbursment_physical_voucher`;
    return apiURL;
  };
  const fetchData = async (paraUrl?: any, canHaveExistingData?: boolean) => {
    setLoadingAPI(physicalVoucherData.length === 0);
    setLoadingAPI(true);
    try {
      let apiUrl = getAPiURL(paraUrl);
      if (lastKey) {
        apiUrl +=
          (apiUrl.includes("?") ? "&" : "?") +
          `lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }
      const voucherResponse = await axios.get(apiUrl);
      let result,
        apiKey = null;
      if (currentRoute === "/merchant/physicalVoucher") {
        result = voucherResponse?.data?.result;
        apiKey = voucherResponse?.data?.lastKey;
      } else {
        result = voucherResponse?.data?.data?.data?.value;
        apiKey = voucherResponse?.data?.data?.data?.lastKey;
      }
      setLastKey(apiKey || null);
      const mappedData = result?.map((item: any, index: any) => ({
        id: item.id ? item.id : "-",
        reportId: item.report_id ? `Report ID # ${item.report_id}` : "-",
        reportIdDetail: item.report_id ? item.report_id : "-",
        merchant: item.merchant_name === "" ? "-" : item.merchant_name,
        companyName: item.company_name === "" ? "-" : item.company_name,
        voucherType: item.voucher_type ? item.voucher_type : "-",
        merchantID: item.merchant_id ? item.merchant_id : "-",
        totalAmount: item.total_amount ? `S$${item.total_amount}` : "-",
        noOfVouchers: item.voucher_count ? item.voucher_count : "-",
        submissionDate: item.createdAt
          ? getFormattedDate(item.createdAt, dateFormat.DMMMMYYYY)
          : "-",
        receivedDate: item?.reimbursement_date
          ? getFormattedDate(item.reimbursement_date, dateFormat.DMMMMYYYY)
          : "-",
        rejectionReason: item.rejection_reason ? item.rejection_reason : "-",
        createdBy: item.created_by ? item.created_by : "-",
        status: item.report_status ? item.report_status : "-",
        navigateTo: `${"/p-voucherDetails/"}${item.report_id}`,
      }));
      const dataToSet = canHaveExistingData
        ? [...pvData, ...mappedData]
        : mappedData;
      setPVData(dataToSet);
      dispatch(
        financeActions.updatePhysicalList({
          physicalVoucher: dataToSet,
        })
      );
      setErrorAPI(false);
      setLoadingAPI(false);
    } catch (error) {
      setErrorAPI(true);
    } finally {
      setLoadingAPI(false);
      setOpen(false);
      setIsApiCall(false);
    }
  };
  const handleCheckboxChange = (item: PVoucherData, checked: boolean) => {
    if (checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((selectedItem) => selectedItem !== item)
      );
    }
  };

  const handleProceed = async () => {
    const validItems = selectedItems.filter(
      (voucher) => voucher.id && voucher.status
    );
    if (validItems.length === 0) {
      console.error("No valid items selected");
      return;
    }
    const status = approval ? filterConstants.Reject : filterConstants.Accept;
    const ids = validItems.map((voucher: any) => ({
      id: voucher.reportId.substring(12),
      report_status: status,
      rejection_reason: rejectionReason,
      merchantId: voucher.merchantID,
    }));
    setLoadingAPI(true);
    try {
      const payload = [...ids];
      const newPayload = {
        type: "physical",
        records: payload,
        module: "finance",
        feature: "reimbursment_physical_voucher",
      };
      const axiosResponse = await axios.patch(
        process.env.REACT_APP_API_URL + APIConstants.proceedReimbursement,
        newPayload
      );
      setShowModal(true);
      setModalTitle(axiosResponse.data.data.message);
      handleClose();
      setSelectedItems([]);
      onSearch();
      // fetchData();
    } catch (error) {
      setShowModal(true);
      setApiError(true);
      console.error(error);
    } finally {
      setLoadingAPI(false);
      setOpen(false);
      setApiError(false);
      setTimeout(() => setShowModal(false), 5000);
    }
  };
  const isValidEmail = (email: any) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email)) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  };
  //
  const handleLocalDownload = () => {
    // const exportableData = formatCSVData(
    //   filteredData ? filteredData : physicalVoucherData
    // );
    const exportableData = formatCSVData(pvData);

    if (exportableData.length > 0) {
      const fields = Object.keys(exportableData[0]);
      const csvRows = [fields.join(",")];

      for (const row of exportableData) {
        const values = fields.map((field) => JSON.stringify(row[field]));
        csvRows.push(values.join(","));
      }

      const csvContent = `Report Title: Physical Voucher Reimbursement Report\nExport Date: ${currentDate}\n${csvRows.join(
        "\n"
      )}`;
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "physical-voucher.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else {
      console.error("No data to export");
    }
  };
  const onInputChange = (filedName: string, value: any, states: any) => {
    states((prevState: any) => ({
      ...prevState,
      [filedName]: value,
    }));
  };
  const getInputValue = (fieldItem: any, states: any) => {
    const item = states[fieldItem as keyof typeof states];
    return item !== undefined ? item : "";
  };
  const getFilterDates = () => {
    const data = Object.keys(updatedDateFilter).map((item: any) => {
      return {
        fieldValue: item,
        value: new Date(
          updatedDateFilter[item as keyof typeof updatedDateFilter]
        )
          .getTime()
          .toString(),
        operator: operatorConstants.equal,
      };
    });
    return data;
  };
  const getFilterAmount = () => {
    const amntData = Object.keys(updatedAmntInput)?.map((item: any) => {
      return updatedAmntInput[item as keyof typeof updatedAmntInput];
    });
    let amntField = {};
    const filterValue = {
      fieldValue: entityConstants.amount,
      value: amntData,
      operator: operatorConstants.between,
    };
    const amnt_data = [];
    amntField = amntData.length > 1 ? amnt_data.push(filterValue) : {};
    return amnt_data;
  };
  const getFilterStatus = () => {
    const statusParam = [];
    if (selectedOption !== "")
      statusParam.push({
        fieldValue: entityConstants.status,
        value: selectedOption,
        operator: operatorConstants.equal,
      });
    return statusParam;
  };
  const getFilterValues = () => {
    const filtertype = getNormalFilter();
    // const dates = getFilterDates();
    const dates = valueWithOperator;
    const amount = getFilterAmount();
    const status = getFilterStatus();
    return [...filtertype, ...dates, ...amount, ...status];
  };
  const bindFilter = (canHaveExistingData?: boolean) => {
    const params = getParams();
    fetchData(params, canHaveExistingData);

    const url = getUrl();
  };
  const getParams = () => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const searchValue = searchInputRef.current
      ? getEncodedValue(searchInputRef.current.value)
      : "";
    const searchParam = searchValue !== "" ? [searchValue] : [];
    const filterItems = getFilterValues();
    const params = {
      hashData: hashValues,
      searchData: searchParam,
      filterData: filterItems,
    };
    return params;
  };
  const getUrl = () => {
    const params = getParams();
    const url = getHashURL(params);
    return url;
  };
  const handleApplyFilter = () => {
    setOpenFilter(false);
    onSearch();
    const filters = getFilterValues().slice(1);
    filters.length && setFilterActive(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const onSearch = () => {
    setPVData([]);
    setLastKey(null);
    setIsApiCall(true);
  };
  const handleResetFilter = () => {
    onResetDate();
    setupdatedDateFilter({});
    setSelecteOption("");
    setUpdatedAmntInput({});
    onSearch();
    setFilterActive(false);
  };
  const onDisableOptions = (item: any) => {
    return !(
      item?.status.toLowerCase() === filterConstants.Reject.toLowerCase() ||
      item?.status.toLowerCase() === filterConstants.Accept.toLowerCase() ||
      item?.status.toLowerCase() === filterConstants.Submitted.toLowerCase()
    );
  };

  const handleSendExport = async () => {
    const getFilterURL = getUrl();
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.reimbursementReport,
      hashKey.placeholderId,
      hashValue.allRecords
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };

  return (
    <Grid>
      <ExportDialog
        closeDialog={setOpenExport}
        emailSent={emailSent}
        exportTitle="Reimbursement Physical Voucher"
        handleClose={handleExportClose}
        open={openExport}
        sending={sending}
        handleSendExport={handleSendExport}
      />
      <Dialog onClose={handleCloseFilter} open={openFilter} sx={{ ml: "60vw" }}>
        <Grid sx={{ width: "483px", py: 4, px: 2 }}>
          <DialogTitle
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thicker,
              }}
            >
              Filter
            </Typography>
            <IconButton onClick={handleCloseFilter}>
              <CloseOutlinedIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontSize: theme.font?.fontSize.medium,
                fontWeight: theme.font?.fontWeight.thick,
              }}
            >
              Total Amount($)
            </Typography>
            <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
              <TextField
                sx={{
                  display: "flex",
                  width: "50%",
                }}
                type="text"
                placeholder="From"
                value={getInputValue(
                  entityConstants.amount_from,
                  updatedAmntInput
                )}
                onChange={(data) =>
                  onInputChange(
                    entityConstants.amount_from,
                    data.target.value,
                    setUpdatedAmntInput
                  )
                }
              />
              <TextField
                sx={{
                  display: "flex",
                  width: "50%",
                }}
                type="text"
                value={getInputValue(
                  entityConstants.amount_to,
                  updatedAmntInput
                )}
                placeholder="To"
                onChange={(data) =>
                  onInputChange(
                    entityConstants.amount_to,
                    data.target.value,
                    setUpdatedAmntInput
                  )
                }
              />
            </Grid>
            {/* <InputProps
              label="Submitted Date"
              value={getInputValue(
                entityConstants.submittedDate,
                updatedDateFilter
              )}
              type="date"
              inputPlaceHolder="From"
              onInputChange={(data) =>
                onInputChange(
                  entityConstants.submittedDate,
                  data.target.value,
                  setupdatedDateFilter
                )
              }
            /> */}
            <DualInputProps
              label="Submitted Date"
              fromTitle="From"
              toTitle="To"
              fromOnChange={(data) => {
                onUpdateFiltedDate(
                  entityConstants.submittedDate,
                  "fromDate",
                  data.target.value
                );
              }}
              toOnChange={(data) => {
                onUpdateFiltedDate(
                  entityConstants.submittedDate,
                  "toDate",
                  data.target.value
                );
              }}
              fromValue={
                selectedDates[
                  entityConstants.submittedDate
                ]?.fromDate?.toString() || ""
              }
              toValue={
                selectedDates[
                  entityConstants.submittedDate
                ]?.toDate?.toString() || ""
              }
              type="Date"
            />
            {/* <InputProps
              label="Received Date"
              value={getInputValue(
                entityConstants.receivedDate,
                updatedDateFilter
              )}
              type="date"
              inputPlaceHolder="From"
              onInputChange={(data) =>
                onInputChange(
                  entityConstants.receivedDate,
                  data.target.value,
                  setupdatedDateFilter
                )
              }
            /> */}
            <DualInputProps
              label="Received Date"
              fromTitle="From"
              toTitle="To"
              fromOnChange={(data) => {
                onUpdateFiltedDate(
                  entityConstants.receivedDate,
                  "fromDate",
                  data.target.value
                );
              }}
              toOnChange={(data) => {
                onUpdateFiltedDate(
                  entityConstants.receivedDate,
                  "toDate",
                  data.target.value
                );
              }}
              fromValue={
                selectedDates[
                  entityConstants.receivedDate
                ]?.fromDate?.toString() || ""
              }
              toValue={
                selectedDates[
                  entityConstants.receivedDate
                ]?.toDate?.toString() || ""
              }
              type="Date"
            />
            <InputProps
              label="Report Status"
              value={selectedOption}
              type="Select"
              inputPlaceHolder="From"
              onInputChange={(data) => {
                setSelecteOption(data.target.value);
              }}
              options={physicalVoucherStateFilter}
            />
          </DialogContent>
          <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
            <Button
              onClick={handleResetFilter}
              sx={{ ...buttonStyle.outlinedSecondary }}
            >
              Reset
            </Button>
            <Button
              sx={{ ...buttonStyle.containedSecondary }}
              onClick={handleApplyFilter}
            >
              Apply
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>

      {constant.domain === process.env.REACT_APP_ADMIN_DOMAIN && (
        <Dialog
          open={openAddDeduct}
          onClose={() => {
            setOpenAddDeduct(false);
            setApproval(false);
          }}
          sx={{ mr: "52vw" }}
        >
          <Grid
            display={"flex"}
            gap={4}
            p={4}
            width={"439px"}
            flexDirection={"column"}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: theme.font?.fontWeight.thicker,
                fontSize: "20px",
              }}
            >
              Receive or Reject
            </Typography>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="options"
                name="options"
                sx={{ fontFamily: theme.font?.fontFamily.primary }}
              >
                <FormControlLabel
                  sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  control={
                    <Radio
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        color: theme.color?.sideGrey,
                        "&.Mui-checked": {
                          color: theme.color?.secondary,
                        },
                      }}
                      checked={!approval}
                      onChange={() => {
                        setApproval(false);
                      }}
                    />
                  }
                  label="Receive"
                />
                <FormControlLabel
                  sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  control={
                    <Radio
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        color: theme.color?.sideGrey,
                        "&.Mui-checked": {
                          color: theme.color?.secondary,
                        },
                      }}
                      checked={approval}
                      onChange={() => {
                        setApproval(true);
                      }}
                    />
                  }
                  label="Reject"
                />
              </RadioGroup>
            </FormControl>
            {!approval && (
              <Grid
                display={"flex"}
                alignItems={"center"}
                gap={2}
                borderTop={theme.border?.newGreyBorder}
                pt={3}
              >
                <CommonButton
                  variant="outlined"
                  color="secondary"
                  buttonTitle="Cancel"
                  onClick={() => {
                    setOpenAddDeduct(false);
                    setApproval(false);
                  }}
                  sx={{ width: "50%" }}
                />
                <CommonButton
                  variant="contained"
                  color="secondary"
                  buttonTitle="Proceed"
                  onClick={() => {
                    setOpenAddDeduct(false);
                    handleClickOpen();
                  }}
                  sx={{ width: "50%" }}
                />
              </Grid>
            )}
            {approval && (
              <Grid display={"flex"} gap={4} flexDirection={"column"}>
                <TextField
                  multiline
                  rows={2}
                  placeholder=""
                  label="Reason"
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  sx={{ background: theme.color?.background }}
                ></TextField>
                <Grid
                  display={"flex"}
                  gap={2}
                  borderTop={theme.border?.newGreyBorder}
                  pt={3}
                >
                  <CommonButton
                    variant="outlined"
                    color="secondary"
                    buttonTitle="Cancel"
                    onClick={() => {
                      setOpenAddDeduct(false);
                      setApproval(false);
                    }}
                    sx={{ width: "50%" }}
                  />
                  <CommonButton
                    variant="contained"
                    color="secondary"
                    buttonTitle="Proceed"
                    onClick={handleClickOpen}
                    sx={{ width: "50%" }}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </Dialog>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid width={"491px"} py={2}>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: theme.font?.fontWeight.thick,
                textAlign: "center",
                color: "black",
                fontSize: theme.font?.fontSize.large,
              }}
            >
              Are you sure you want to <br></br>{" "}
              {approval
                ? filterConstants.Reject.toLowerCase()
                : filterConstants.receive}{" "}
              this report
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
            {loadingAPI ? (
              <CircularProgress size={24} />
            ) : (
              <>
                <Button
                  sx={{ ...buttonStyle.outlinedSecondary, width: "40%" }}
                  onClick={handleClose}
                  autoFocus
                >
                  Cancel
                </Button>
                <Button
                  sx={{ ...buttonStyle.containedSecondary, width: "40%" }}
                  onClick={handleProceed}
                >
                  OK
                </Button>
              </>
            )}
          </DialogActions>
        </Grid>
      </Dialog>
      <Grid
        container
        item
        alignItems={"center"}
        justifyContent={"space-between"}
        py={2}
        px={4}
        width={"100%"}
      >
        {getPhysicalPermission("update") && (
          <Button
            sx={{
              ...buttonStyle.containedSecondary,
              background:
                selectedItems.length === 0 ? theme.color?.secondaryLight : "",
            }}
            onClick={() => setOpenAddDeduct(true)}
            disabled={selectedItems.length === 0}
          >
            Receive / Reject
          </Button>
        )}
        <Grid
          display={"flex"}
          gap={1}
          justifySelf={"end"}
          alignItems={"center"}
        >
          {getPhysicalPermission("export") && (
            <CommonButton
              buttonTitle="Export"
              variant="text"
              color="secondary"
              onClick={handleExport}
              disabled={!pvData.length}
            />
          )}
          {getPhysicalPermission("download") && (
            <CommonButton
              buttonTitle="Download"
              variant="text"
              color="secondary"
              onClick={handleLocalDownload}
              disabled={!pvData.length}
              endIcon={<DownloadForOfflineRoundedIcon />}
            />
          )}
          <SearchInput
            HelpTip={SearchToolTip.VoucherReimb}
            onCallBack={onSearch}
            ref={searchInputRef}
          />
          <Button
            variant="text"
            startIcon={
              filterActive ? (
                <FilterAltIcon sx={{ color: theme.color?.secondary }} />
              ) : (
                <FilterAltOutlinedIcon />
              )
            }
            sx={{
              color: theme.color?.newFilterGrey,
              textTransform: "capitalize",
            }}
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            Filter
          </Button>
        </Grid>
      </Grid>
      <Grid container width={"100%"} px={2} mt={2}>
        {getPhysicalPermission("read") && (
          <InfiniteTable
            header={
              constant.domain === process.env.REACT_APP_ADMIN_DOMAIN
                ? columnsAdmin
                : columnsMerchant
            }
            contentItems={pvData}
            fetchMoreData={() => bindFilter(true)}
            hasMoreRecords={lastKey !== null}
            onInputChange={handleCheckboxChange}
            filterCondition={onDisableOptions}
            isInitialLoading={pvData.length === 0 && loadingAPI}
            totalRecords={totalCount}
          />
        )}
      </Grid>
      {showModal &&
        (apiError ? (
          <BasicModal
            title={modalTitle}
            success={false}
            setState={setShowModal}
          />
        ) : (
          <BasicModal
            title={modalTitle}
            success={true}
            setState={setShowModal}
          />
        ))}
    </Grid>
  );
};

export default ReimbursementPhysicalVoucher;
